export const campaignRoutes = {
  app: {
    createCampaign: '/app/campaigns',
    getCampaign: '/app/campaigns/:id',
    getCampaigns: '/app/campaigns',
    getZipCodes: '/app/campaigns/:id/zip-codes',
    getZipDraft: '/app/campaigns/:id/zip-codes/draft/:group',
    getCampaignPausedReasons: '/app/campaigns/:id/paused-reasons',
    getCampaignsList: '/app/campaigns/list',
    resetPassword: '/app/passwords/reset',
    submitCampaign: '/app/campaigns/:id/submit',
    submitZips: '/app/campaigns/:id/zip-codes/draft/valid/submit',
    updateCampaign: '/app/campaigns/:id',
    updateCard: '/app/cards/:id',
    getCampaignSettings: '/app/campaigns/:id/settings',
  },
  internal: {
    getCampaign: '/internal/campaigns/:id',
    getCampaigns: '/internal/campaigns',
    getZipCodesCounts: '/internal/campaigns/:id/zip-codes/counts',
    getZipCodes: '/internal/campaigns/:id/zip-codes',
    getZipDraft: '/internal/campaigns/:id/zip-codes/draft/:group',
    getCampaignNotes: '/internal/campaigns/:id/notes',
    createCampaignNote: '/internal/campaigns/:id/notes',
    getCampaignPausedReasons: '/internal/campaigns/:id/paused-reasons',
    getCampaignsOutOfGroups: '/internal/campaigns/out-of-groups',
    getGeneratedItemsCounter: '/internal/campaigns/:id/overlapping/generated-items-counters',
    getCampaignOverlappingSummary: '/internal/campaigns/:id/overlapping/summary',
    getOverlappingCampaigns: '/internal/campaigns/:id/overlapping/campaigns',
    getOverlappingForecast: '/internal/campaigns/:id/overlapping/performance-forecast',
    getZipCodesCounters: '/internal/campaigns/:id/overlapping/zip-codes-counters',
    approveCampaign: '/internal/campaigns/:id/approve',
    campaignEmailIntegrations: '/internal/campaigns/:campaignId/email-integrations',
    deactivate: `/internal/campaigns/:id/deactivate`,
    runForce: `/internal/campaigns/:id/activate/force`,
    getCampaignsList: '/internal/campaigns/list',
    submitZips: '/internal/campaigns/:id/zip-codes/draft/valid/submit',
    updateCampaign: '/internal/campaigns/:id',
    getZipCodesCSV: '/internal/campaigns/:id/zip-codes/export',
    getUniqueCampaignZips: '/internal/campaigns/:id/unique-zips/export',
    getContractorsOutOfGroups: '/internal/campaigns/out-of-groups/contractors',
    getOutOfGroupCampaignZIP: '/internal/campaigns/:groupId/zip-codes-in-use/export',
    getOverlappingZIP: '/internal/campaigns/:campaignId/overlapping/zip-codes/export/:type',
    getCallCenterRestrictionTimeRange: '/internal/schedules/call-centers/homebuddy',
    getTestLeadCrmHistoryJSON: '/internal/campaigns/:id/test-lead-crm-history/:historyId/export',
  },
};
